exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".home header{height:600px;background:url(\"http://sporte.io/images/Backgrounds/TennisCenter.jpg\")}.home h1{color:#fff;font-size:300%;padding:25% 0}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/Home.vue"],"names":[],"mappings":"AACA,aACE,aAAc,AACd,sEAAwE,CACzE,AACD,SACE,WAAa,AACb,eAAgB,AAChB,aAAe,CAChB","file":"Home.vue","sourcesContent":["\n.home header { \n  height: 600px;\n  background: url('http://sporte.io/images/Backgrounds/TennisCenter.jpg');\n}\n.home h1 {\n  color: white;\n  font-size: 300%;\n  padding: 25% 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e1d3e61","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home.vue
// module id = 724
// module chunks = 19